import { render } from "./Index.vue?vue&type=template&id=bd8eb19a&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=bd8eb19a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bd8eb19a"

export default script